function FooterNav({ posts }) {
	return {
		$template: '#template-footerNav',
		posts,
		mounted(el) {
			let $border = $(".borderbox", el)
			let now = 0
			let total = $border.length
			let wrapper = gsap.utils.wrap(now, total)


			let trans = (i) => {
				let next = wrapper(now + 1)

				gsap.timeline({
					onComplete: function() {
						now = next
						trans(wrapper(now))
					}
				}).to($border.eq(i), {
					duration: 1,
					opacity: 1,
				}).to($border.eq(i), {
					delay: 2, 
					duration: 1,
					opacity: 0,
				})
			}

			trans(now)
		}
	}
}


export {
	FooterNav,
}